import { useQuery } from '@tanstack/react-query';
import { assetTicket } from './api';

/** Haelt ein gueltiges Zugriffsticket fuer Bild-URLs bereit (Refresh alle 10 Minuten). */
export function useAssetTicket(): string | undefined {
  const { data } = useQuery({
    queryKey: ['asset-ticket'],
    queryFn: assetTicket,
    staleTime: 10 * 60_000,
    refetchInterval: 10 * 60_000,
  });
  return data;
}
